module.exports = __webpack_public_path__ + "static/media/features-recruitment.4c58dc67.png";